import type { Custody } from '@infinex/types';

/** Safe send/move only quote fungibles today — block NFT/collectible picks. */
export function isSafeSourceNftUnsupported(
  custody: Custody | undefined
): boolean {
  return custody === 'multi-sig';
}

export const SAFE_SOURCE_NFT_UNSUPPORTED = {
  title: 'Not supported from Safes yet',
  disabledReason: 'NFTs and collectibles from a Safe are not supported yet.',
} as const;
